// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".listgames__title {\n  display: flex;\n  align-items: center;\n}\n.listgames__img {\n  flex: 0 0 auto;\n  height: 28px;\n  width: 28px;\n  margin-right: 12px;\n}", ""]);
// Exports
module.exports = exports;
